module.exports = __webpack_public_path__ + "tenant-promote.f19a38153761cb378dcb7259a3fc3241.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/tenants/intro/tenant-promote.png
// module id = 7817897101628597
// module chunks = 1